import { createFileRoute } from "@tanstack/react-router"

import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { routeGuard } from "@/lib/routing/beforeLoad"

import { templateName } from "./-templateQuery"

export const Route = createFileRoute("/_authlayout/_header/templates/$id/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context }) => context.queryClient.query({ ...getBoardsQueryOptions(), staleTime: "static" }),
  head: ({ match }) => {
    const title = templateName(match.context.templateQuery) || "Template"

    return { meta: [{ title: `${title} | Arduino Cloud` }] }
  }
})
